

import { Component, Vue } from "vue-property-decorator";
import { CustomerListDto, getMerchantsList } from "@/api/customerManage";
import ClientCard from "@/views/customerManage/template/ClientCard.vue";
import SearchNav from "@/components/SearchNav/index.vue";

@Component({
  name: 'SearchCustomer',
  components: { SearchNav,ClientCard }
})
export default class SearchCustomer extends Vue {
  value = ''
  customerList: CustomerListDto[] = []
  params = {
    levelId: '',
    tagId: '',
    groupId: '',
    pageIndex: 1,
    pageSize: 10,
    merchantsName: '',
    isPage: true
  }
  // 折叠面板
  collapseActive = []

  created () {
    this.params.tagId = (this.$route.query.tagId as string)
    this.params.groupId = (this.$route.query.groupId as string)
    this.params.levelId = (this.$route.query.levelId as string)
    // this.getList()
  }

  getList () {
    if (this.value.trim() === '') {
      this.$toast('请输入客户名称/备注名称')
      return
    }
    this.params.merchantsName = this.value
    getMerchantsList(this.params).then((res) => {
      this.customerList = res.data.records.map(item => {
        return {
          ...item,
          isOpen: false // 控制折叠板展开收起，默认false收起
        }
      })
    })
  }

  /**
   * @description: 搜索事件
   * @param {*} val
   * @return {*}
   */
  onSearch (val) {
    this.value = val
    this.getList()
  }

  beforeClose ({ position, instance }) {
    switch (position) {
      case 'cell':
        break;
      case 'outside':
        instance.close();
        break;
    }
  }

  /**
   * 打开详情页
   * @param e
   * @param id 关联id
   * @param merchantsId 客户编号
   */
  toDetail (e: string, id: string, merchantsId: string) {
    if (e === 'cell') {
      if(!this.$isAction('clientDetail')) return false
      this.$router.push({
        path: '/clientDetail',
        query: {
          relationId: id,
          merchantsId: merchantsId
        }
      })
    }
  }
}
